import { Component, ElementRef, HostListener, Input, OnInit} from '@angular/core';
import { Router } from '@angular/router';
import {PartnerOffer } from 'src/app/shared/models/data.model'
import { _windowUtil } from '../../utils/ui-utils';
import { properties } from 'src/environments/properties';
import { ParamService } from '../../services/param.service';

@Component({
  selector: 'app-partnerscard',
  templateUrl: './partnerscard.component.html',
  styleUrls: ['./partnerscard.component.scss']
})
export class PartnerscardComponent implements OnInit {

  banner: string;
  
  @Input() offer: PartnerOffer ;
  @Input() userInfo: any;
  @Input() cardIndex: number;
  @Input() configObj?: any = {
    programType: '',
    appName: ''
  };

  //claim offer CTA is detertmined solely based on offer obj
  enableClaimOfferCTA: boolean;
  public windowUtil = _windowUtil(window);
  partnersOfferDisplay: PartnerOffer ;
  displayCard: boolean = false;

  scrWidth : any;
  viewPort = 'desktop';
  imageAltText: string = '';
  LONG_TERM_OFFER_TYPE = 'long-time-offer';
  
  enablePartnersOffersV2: boolean = false;

  properties = properties;
  enableForUPlus: boolean = this.properties.featureFlags.enableForUPlus;
  programDisplayData = this.enableForUPlus ? this.properties.programType.forUPlus : this.properties.programType.freshpass;

  constructor(public elementRef: ElementRef,
     private router: Router,
      public paramService: ParamService) {
        this.banner = this.paramService.banner;
        const partnerPromotionBannerConfig = this.properties.featureFlags.partnerPromotionBannerConfig;
        this.enablePartnersOffersV2 = this.properties.featureFlags.enablePartnersOffersV2 && partnerPromotionBannerConfig[this.banner] === true;
  }

  ngOnInit(): void {
    if (this.offer) {
      this.partnersOfferDisplay = this.normalizePartnerOffer(this.offer);
      this.displayCard = true;
    }
  }
  @HostListener('window:resize', ['$event'])
    getScreenSize(event?) {
      this.scrWidth = window.innerWidth;
      if(this.scrWidth >= 768) {
          this.viewPort = 'desktop';
      } else{
          this.viewPort = 'mobile';
      }
      this.setPartnerImage();
    }

    ngAfterViewInit() {
      this.setPartnerImage();
    }

    setPartnerImage() {
      const imgElement = this.elementRef.nativeElement.querySelector('.partners-offer-img');
        if (imgElement) {
            imgElement.style.backgroundImage = this.getImageUrl(this.viewPort);
            imgElement.style.backgroundRepeat = 'no-repeat';
            imgElement.style.backgroundSize = '100% 100%';
        }
    }

    public getImageUrl(viewport: string): string {
      let imageRef = '';
      let imgPath = '';
      const bgImgPath = this.partnersOfferDisplay?.bgImgPath;
      if (bgImgPath) {
          const modifiedImagePath = bgImgPath?.replace(/\$.*/, '');
          if (viewport === 'desktop') {
              imgPath = '?$partner-cards-desktop$&defaultImage=Not_Available';
          } else {
              imgPath = '?$partner-cards-tablet$&defaultImage=Not_Available';
          }
          imageRef = 'url(' + modifiedImagePath + imgPath + ')'
      }
      return imageRef;
    }

  private normalizePartnerOffer(offer: PartnerOffer ): PartnerOffer {
    let normalizedOffer;

    if (this.enablePartnersOffersV2) {
      normalizedOffer = {
        partnerName: offer?.partnerName || '',
        title: offer?.title || '',
        subTitle: offer?.subTitle || '',
        ctaText: offer?.webCtaProps?.ctaText,
        ctaAltText: offer?.webCtaProps?.ctaAltText,
        ctaLink: offer?.webCtaProps?.ctaLink,
        ctaNewTab: offer?.webCtaProps?.newTab,
        includedBanners: offer?.includedBanners || [],
        promoCode: offer?.promoCode || '',
        startDate: offer?.startDate || '',
        endDate: offer?.endDate || '',
        displayOrder: offer?.displayOrder || '',
        partnerProgramType: offer?.partnerProgramType || '',
        bannerType: offer?.bannerType || '',
        userTypes: offer?.userTypes || [],
        bgImgPath: offer?.bgImgPath || '',
        bgImgAltText: offer?.bgImgAltText || '',
        ctaLinkMobile: offer?.ctaLinkMobile || '',
        enableCta:offer?.enableCta || false,
        hideCta: offer?.hideCta || false,
        isOfferRedeemed: offer?.isOfferRedeemed || false,
        contentPath: offer?.contentPath || '',
        partnerOfferId: offer?.partnerOfferId || '',
        isStatic: offer?.isStatic || false,
        staticPromo: offer?.staticPromo || '',
        partnerExternalUrl: offer?.partnerExternalUrl || '',
        bgImgFileReference: offer?.bgImgFileReference || '',

        paidMembershipTitle: offer?.paidMembershipTitle || '',
        paidMembershipSubTitle: offer?.paidMembershipSubTitle || '',
        paidMembershipImgPath: offer?.paidMembershipImgPath,
        paidMembershipImgAltText: offer?.paidMembershipImgAltText,
        paidMembershipSegment: offer?.paidMembershipSegment,
        partnerOfferType: offer?.partnerOfferType || '',
      };

      if (offer?.partnerOfferType?.toLowerCase() === this.LONG_TERM_OFFER_TYPE) {
        normalizedOffer = this.updateLongTimeOfferProps(offer, normalizedOffer);
      }
    } else {
      normalizedOffer = {
        title: offer.title || '',
        subTitle: offer.subTitle || '',
        ctaText: offer.ctaText || '',
        includedBanners: offer.includedBanners || [],
        startDate: offer.startDate || '',
        endDate: offer.endDate || '',
        displayOrder: offer.displayOrder || '',
        partnerProgramType: offer.partnerProgramType || '',
        bannerType: offer.bannerType || '',
        userTypes: offer.userTypes || [],
        ctaLink: offer.ctaLink || '',
        bgImgPath: offer.bgImgPath || '',
        bgImgAltText: offer.bgImgAltText || '',
        ctaLinkMobile: offer.ctaLinkMobile || '',
        enableCta:offer?.enableCta || false,
        hideCta: offer?.hideCta || false,
        isOfferRedeemed: offer?.isOfferRedeemed || false,
        contentPath: offer.contentPath || '',
        partnerOfferId: offer.partnerOfferId || '',
        isStatic: offer.isStatic || false,
        staticPromo: offer.staticPromo || '',
        partnerExternalUrl: offer.partnerExternalUrl || '', 
        bgImgFileReference: offer.bgImgFileReference || '',
      };
    }
    this.getClaimOfferCTA(normalizedOffer)
    return normalizedOffer;
  }

  getClaimOfferCTA(offer: PartnerOffer) {
    if (this.enablePartnersOffersV2) {
      this.enableClaimOfferCTA = offer.hideCta ? false : true;
    } 
    else {
      this.enableClaimOfferCTA = offer.enableCta ? true : false;
    }
  }

  onClickCTA(event) {
    const { contentPath, partnerOfferId, isStatic, staticPromo, partnerExternalUrl, partnerName } = this.partnersOfferDisplay;
    const storageData = {
        partnerName,
        contentPath,
        partnerOfferId,
        isStatic,
        staticPromo: staticPromo.trim() === '' ? null : staticPromo,
        partnerExternalUrl,
        userInfo: this.userInfo
    };
    localStorage.setItem('partnerDetails', JSON.stringify(storageData));
    if (window['AB'] && window['AB']['DATALAYER']) {
      const linkName = event.target.classList.contains('offer-btn-container') || event.target.classList.contains('offerClaimCTA') ? `:${this.partnersOfferDisplay.ctaText?.toLowerCase()?.replace(/ /g, '-')}` : '';
      window['AB']['DATALAYER'].setLinkClickEvents(`for-u-partner-offers|${this.partnersOfferDisplay.title?.toLowerCase()?.replace(/ /g, '-')}${linkName}`, true);
    }
    this.handleOfferRedirects()
  }

  handleOfferRedirects() {
    if (this.partnersOfferDisplay.partnerOfferType === this.LONG_TERM_OFFER_TYPE) {
      const longTimeOfferrRedirectPath = this.partnersOfferDisplay?.ctaLink;
      this.windowUtil.openInNewWindowTab(longTimeOfferrRedirectPath);
    } else {
      this.windowUtil.setWindowLocationHref(`${this.programDisplayData?.urlPath?.REWARDS_PARTNERS_DETAILS_PATH}?freshpass=true`);
    }
  }

  updateLongTimeOfferProps(offer: PartnerOffer, normalizedOffer: PartnerOffer): PartnerOffer {
    let updatedOffer = {
        ...normalizedOffer,
        title: offer?.paidMembershipTitle || '',
        subTitle: offer?.paidMembershipSubTitle || '',
        bgImgPath: offer?.paidMembershipImgPath || '',
        bgImgAltText: offer?.paidMembershipImgAltText || '',
      };
    return updatedOffer;
  }
}
